export const MAX_BIRTH_YEAR = 1390